import type { FaireProductEntity } from "../../entity_types/product";

export const p_shq7w9zn9b: FaireProductEntity = {
  token: "p_shq7w9zn9b",
  type: "product",
  name: "C4A54-WB16 V NECK LACE TRIM DOUBLE STRAPS MAXI DRESS",
  brandToken: "b_dkldnd6ff4",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/64512336ed5a62efb60a5f809cde7834658f405d8fb5a0bdd9652d4b11f5cb27.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/29441de406ecc4ebfa85e9506bdd555f90d03fb732fba1890023e12e70bac565.jpeg",
    "https://cdn.faire.com/fastly/bba6aeae5d4a856b4ad41e91182dcc6b25bed84f6289bd542b1416f3c4fac01c.jpeg",
    "https://cdn.faire.com/fastly/1dcc1a252afe8e4671ea8d569bfcc67465831bf54e0312021ab519dfe36aefbb.jpeg",
    "https://cdn.faire.com/fastly/96e5d18cb7e262c5c141f1f64c8963836310e327d54bfb332dc1b58aa3f8003f.jpeg",
    "https://cdn.faire.com/fastly/18412e65743d04b92c4b8d765e6ddf5f594757aa54eb40f08f925a124c9ab175.jpeg",
    "https://cdn.faire.com/fastly/dde957f94fe1336cf10ce3d4b1b8dfb6a88f7178c60eb7ecf1fbe3fb2ccbfa3e.jpeg",
  ],
  priceDollars: 187.07,
  description:
    "Step into the world of boho-chic fashion with the C4A54-WB16 V Neck Lace Trim Double Straps Maxi Dress from Angie. This dress, with its V-neck lace trim and double straps, encapsulates the well-traveled, romantic spirit that Angie is renowned for. The maxi length gives it a touch of elegance, while the unique design elements add a bohemian vibe. Ideal for the woman who embraces a global lifestyle, this dress is a testament to Angie's commitment to bringing wearable art to life. It's more than just a dress; it's a lifestyle.",
  tags: [],
  msrpDollars: 374.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:29.826Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
